import { useState } from 'react';
import emailjs from '@emailjs/browser';

export type SubmitStatus = 'idle' | 'sending' | 'success' | 'error';

interface UseEmailJSReturn {
  status: SubmitStatus;
  send: (params: Record<string, unknown>) => void;
  reset: () => void;
}

export function useEmailJS(): UseEmailJSReturn {
  const [status, setStatus] = useState<SubmitStatus>('idle');

  const send = (params: Record<string, unknown>): void => {
    const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID ?? '';
    const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID ?? '';
    const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY ?? '';

    setStatus('sending');
    try {
      emailjs
        .send(serviceId, templateId, params, publicKey)
        .then(() => setStatus('success'))
        .catch(() => setStatus('error'));
    } catch {
      setStatus('error');
    }
  };

  const reset = (): void => setStatus('idle');

  return { status, send, reset };
}
